import { Theme } from '../../../../jss';

export const GetSocialClassBase = (theme: Theme) => {
  return {
    '& .get-social-content': {
      textAlign: 'center',
    },
    '& .get-social-header': {
      textAlign: 'center',
      color: theme.palette.mainBackgroundColor,
      fontSize: `${theme.sizing.fontXL}rem`,
      margin: '0px',
      padding: `3rem 0rem 0rem`,
      fontFamily: theme.typography.contentFontFamily,
      fontweight: '600',
    },
    '& .get-social-insta': {
      color: theme.palette.mainBackgroundColor,
      textAlign: 'center',
      fontFamily: theme.typography.mainFontFamily,
      margin: '0px',
      padding: `0rem 0rem ${theme.sizing.paddingM}rem`,
    },
    '& .get-social-images-container': {
      maxWidth: '290px',
      margin: '0 auto',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-evenly',
      padding: `0rem ${theme.sizing.paddingS}rem`,
      paddingBottom: '16px',
      '@media (min-width: 768px)': {
        maxWidth: '590px',
        justifyContent: 'center',
      },
      '@media (min-width: 1024px)': {
        maxWidth: '990px',
        justifyContent: 'center',
      },
    },
    '& .get-social-link': {
      width: '8rem',
      height: 'auto',
      padding: `4px 0rem`,
      cursor: 'pointer',
      '@media (min-width: 768px)': {
        padding: `${theme.sizing.paddingXS}rem`,
      },
      '@media (min-width: 1024px)': {
        width: '12rem',
        height: '12rem',
        padding: `${theme.sizing.paddingM}rem`,
      },
    },
    '& .get-social-image': {
      width: '100%',
    },
  };
};
